import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Image, Card, Modal, Text, ActionIcon } from "@mantine/core";
import { IconEdit, IconExternalLink } from "@tabler/icons-react";

import { GeospotForm } from "./";

import generateStaticMap from "@util/generateStaticMap";

export default function GeospotItem({ editable, data, fetchData, id }) {
  const { t } = useTranslation();
  const [editing, setEditing] = useState(false);
  if (!data) return null;

  function onClose() {
    setEditing(false);
  }

  return (
    <Card
      mb="xs"
      style={{
        overflow: "hidden",
      }}
    >
      {data.latitude && data.longitude && (
        <Card.Section mb="sm">
          <Image
            height={250}
            // mah={250}
            alt={`${data.name} map`}
            style={{
              overflow: "hidden",
            }}
            src={generateStaticMap(
              { latitude: data.latitude, longitude: data.longitude },
              { width: 500, height: 250 }
            )}
          />
        </Card.Section>
      )}
      <Flex gap="xs" align="center">
        <Text fw={600} lineClamp={1}>
          {data.name}
        </Text>
        {data.children && <React.Fragment>{data.children}</React.Fragment>}
        {editable && (
          <ActionIcon
            color="gray"
            variant="light"
            radius="xl"
            size="xs"
            onClick={() => setEditing(true)}
          >
            <IconEdit size={12} />
          </ActionIcon>
        )}
        {editable && (
          <ActionIcon
            color="gray"
            variant="light"
            radius="xl"
            size="xs"
            title="View on Google Maps"
            onClick={() => {
              window.open(
                `https://www.google.com/maps?q=${data.latitude},${data.longitude}&z=17.82`,
                "_blank"
              );
            }}
          >
            <IconExternalLink size={12} />
          </ActionIcon>
        )}
      </Flex>
      {data.address_1 && (
        <Text c="dimmed" size="sm" lineClamp={1}>
          {data.address_1} {data.city}, {data.state_province} {data.zip}
        </Text>
      )}
      <Modal
        opened={editing}
        onClose={onClose}
        title={t("mixer:geospot:update_geospot")}
      >
        <GeospotForm
          id={id}
          name={data.name}
          address1={data.address_1}
          address2={data.address_2}
          city={data.city}
          state={data.state_province}
          zip={data.zip}
          country={data.country}
          onSuccess={() => {
            fetchData();
            onClose();
          }}
        />
      </Modal>
    </Card>
  );
}
